import { render, staticRenderFns } from "./now-widget.component.vue?vue&type=template&id=8677ad2a&scoped=true"
import script from "./now-widget.component.vue?vue&type=script&lang=ts"
export * from "./now-widget.component.vue?vue&type=script&lang=ts"
import style0 from "./now-widget.component.vue?vue&type=style&index=0&id=8677ad2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8677ad2a",
  null
  
)

export default component.exports